import classNames from 'classnames';

import { setupForDark } from '@theme';

export default function SecondaryAction({ text, onClick }: { text: string; onClick: () => void }) {
  return (
    <div
      className={classNames(
        'flex flex-row items-center justify-center',
        'A2M',
        setupForDark('text-secondary'),
        'underline'
      )}
      onClick={onClick}
    >
      {text}
    </div>
  );
}
